"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uiSchema_1 = require("../../common/appointment/uiSchema");
exports.default = {
    type: "VerticalLayout",
    elements: [
        (0, uiSchema_1.makeAppointmentUiSchema)("futureAppointment", "Visit", {
            disablePast: true,
        }),
        (0, uiSchema_1.makeAppointmentConflictsUiSchema)("futureAppointment"),
        {
            type: "Control",
            label: "Notes",
            scope: "#/properties/notes",
        },
    ],
};
